import { Box } from "@chakra-ui/layout";
import { Modal } from "antd";
import useUploadAnexos from "core/features/arquivo/useUploadAnexos";
import useSaveTransferencia from "features/transferencia/hooks/useSaveTransferencia";
import { TransferenciaForm } from "features/transferencia/typings";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "ui/components/Button/FooterModal";
import FormTransferencia from "./FormTransferencia";
import { TransferenciaCreateResponse } from "features/transferencia/typings/index";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import useParametrosCobrancaTransferencia from "core/features/condominio/hooks/useParametrosCobrancaTransferencia";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";

interface ModalTransferenciaProps {
  visible: boolean;
  onClose: () => any;
  onSuccess?: (result: TransferenciaCreateResponse) => any;
  refetch?: () => any;
  defaultData?: Partial<TransferenciaForm>;
}
function ModalTransferencia({
  visible,
  onClose,
  onSuccess,
  refetch,
  defaultData,
}: ModalTransferenciaProps) {
  const { tenant } = useCurrentTenant();

  const { data, isLoading: isLoadingParametros } =
    useParametrosCobrancaTransferencia(tenant.id);

  useUploadAnexos();
  const { mutate: saveTransferencia, isLoading: isLoadingSave } =
    useSaveTransferencia();
  const { control, handleSubmit, reset, formState, watch, setValue } =
    useForm<TransferenciaForm>({
      reValidateMode: "onChange",
      mode: "onChange",
      defaultValues: {
        anexos: [],
        ...defaultData,
      },
    });

  const onError = (err: unknown) => {
    showErrorAxios(err);
  };

  const onSubmit = async (data: TransferenciaForm) => {
    const _data = {
      ...data,
      anexos: data.anexos?.filter(((file) => !(file instanceof File)) ?? []),
    };

    saveTransferencia(_data, {
      onSuccess: () => {
        setTimeout(() => {
          refetch?.();
          onClose();
        }, 200);

        showSuccess().then(({ isConfirmed }) => {
          if (isConfirmed) {
            onClose();
          }
        });
      },
      onError,
    });
  };

  const form = watch();
  useEffect(() => {
    if (
      form.contaDestinoId &&
      form.contaOrigemId &&
      form.contaOrigemId === form.contaDestinoId
    ) {
      setValue("contaDestinoId", undefined);
    }
  }, [form, setValue]);

  useEffect(() => {
    if (visible) {
      reset({
        anexos: [],
        ...defaultData,
        categoriaTransferenciaEnvioId: data?.categoriaTransferenciaEnvioId,
        categoriaTransferenciaRecebimentoId:
          data?.categoriaTransferenciaRecebimentoId,
      });
    }
  }, [
    data?.categoriaTransferenciaEnvioId,
    data?.categoriaTransferenciaRecebimentoId,
    defaultData,
    reset,
    visible,
  ]);

  const _isLoadingMutate = isLoadingSave || isLoadingParametros;

  return (
    <>
      <Modal
        centered
        visible={visible}
        destroyOnClose
        footer={
          <FooterModal
            onSubmit={() => handleSubmit(onSubmit)()}
            isLoadingSave={_isLoadingMutate}
            onClose={onClose}
            isDisabled={_isLoadingMutate || !formState.isValid}
            registerAnother={false}
            showRegisterAnother={false}
            primaryButtonText="Transferir"
          />
        }
        onCancel={onClose}
        width="600px"
      >
        <Box>
          <FormTransferencia
            control={control}
            form={form}
            setValue={setValue}
          />
        </Box>
      </Modal>
    </>
  );
}

export default ModalTransferencia;
